export const profileFormConfig = [
  // ================= PACKAGE & EXPERIENCE =================
  {
    title: "Package & Experience",
    type: "section",
    fields: [
      {
        type: "group",
        label: "Total Experience",
        fields: [
          {
            name: "experienceYears",
            master: "experienceYears",
            placeholder: "Years"
          },
          {
            name: "experienceMonths",
            master: "experienceMonths",
            placeholder: "Months"
          }
        ]
      },
      {
        type: "group",
        label: "Current Salary",
        fields: [
          {
            name: "currentLakh",
            master: "salaryLakhs",
            placeholder: "Lakhs"
          },
          {
            name: "currentThousand",
            master: "salaryThousands",
            placeholder: "Thousands"
          }
        ]
      },
      {
        type: "group",
        label: "Expected Salary",
        fields: [
          {
            name: "expectedLakh",
            master: "salaryLakhs",
            placeholder: "Lakhs"
          },
          {
            name: "expectedThousand",
            master: "salaryThousands",
            placeholder: "Thousands"
          }
        ]
      },
      {
        type: "select",
        label: "Notice Period",
        name: "noticePeriod",
        master: "noticePeriods",
        placeholder: "Select Notice Period"
      }
    ]
  },

  // ================= EDUCATION =================
  {
    title: "Education",
    type: "array",
    name: "education",
    fields: [
      {
        type: "select",
        label: "Degree",
        name: "degree",
        master: "degrees"
      },
      {
        type: "select",
        label: "Course",
        name: "course",
        master: "courses"
      },
      {
        type: "select",
        label: "Specialization",
        name: "fieldOfStudy",
        master: "specializations"
      },
      {
        type: "input",
        label: "Institution",
        name: "institution"
      },
      {
        type: "select",
        label: "Start Year",
        name: "startYear",
        master: "startYears"
      },
      {
        type: "select",
        label: "End Year",
        name: "endYear",
        master: "endYears"
      },
      {
        type: "select",
        label: "Grade",
        name: "grade",
        master: "grades"
      }
    ]
  },

  // ================= EMPLOYMENT =================
  {
    title: "Employment",
    type: "array",
    name: "workExperience",
    fields: [
      {
        type: "input",
        label: "Company",
        name: "company"
      },
      {
        type: "select",
        label: "Department",
        name: "department",
        master: "departments"
      },
      {
        type: "select",
        label: "Category",
        name: "category",
        master: "roleCategories"
      },
      {
        type: "select",
        label: "Subcategory",
        name: "subCategory",
        master: "roleSubCategories"
      },
      {
        type: "select",
        label: "Role",
        name: "role",
        master: "roles"
      },
      {
        type: "select",
        label: "Designation",
        name: "designation",
        master: "designations"
      },
      {
        type: "multi-select",
        label: "Skills",
        name: "skills",
        master: "skillsMaster"
      },
      {
        type: "input",
        label: "Start Date",
        name: "startDate",
        inputType: "month"
      },
      {
        type: "input",
        label: "End Date",
        name: "endDate",
        inputType: "month"
      }
    ]
  }
];